export default __webpack_public_path__ + "static/media/arrow-right.ec9adf44.svg";